import {
  ImageSliceDefault,
  ImageSliceWithMargins,
  IPrismicImage,
} from '@monofront/types';
import { IImageSingleFullWidth, IImageWithMargins } from './types';
import * as prismic from '@prismicio/client';

const mapPrismicImage = (
  prismicImage: prismic.ImageField<never>,
): IPrismicImage | null => {
  return prismicImage.url
    ? {
        url: prismicImage.url,
        alt: prismicImage.alt as string,
        dimensions: {
          height: prismicImage.dimensions.height,
          width: prismicImage.dimensions.width,
        },
      }
    : null;
};

export const mapSingleFullWidth = ({
  primary,
}: ImageSliceDefault): IImageSingleFullWidth => {
  return {
    image: mapPrismicImage(primary.image),
    mobileImage: mapPrismicImage(primary.mobile_image),
  };
};

export const mapWithMargins = ({
  primary,
}: ImageSliceWithMargins): IImageWithMargins => {
  return {
    images: primary.images.map(({ image, mobile_image: mobileImage }) => ({
      image: mapPrismicImage(image),
      mobileImage: mapPrismicImage(mobileImage),
    })),
  };
};
